import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../store";
import { useAppDispatch } from "../hooks";
import { logout } from "../slices/auth";
import { isTokenExpired } from "../helpers";
import { installSessionHandler } from "../services/api";
import EventBus from "../common/EventBus";

export default function SessionManager() {
  const user = useSelector((state: RootState) => state.auth.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const endSession = () => {
      dispatch(logout());
      navigate("/login", { replace: true });
    };
    const uninstall = installSessionHandler(endSession);
    EventBus.on("logout", endSession);
    const check = () => { if (user && isTokenExpired(user)) endSession(); };
    check();
    const timer = window.setInterval(check, 1000);
    return () => {
      uninstall();
      EventBus.remove("logout", endSession);
      window.clearInterval(timer);
    };
  }, [user, dispatch, navigate]);
  return null;
}
